import { Dispatch } from 'react';
import { BopReportItem, GpReportPayload, PaginateListMore } from '../pages/Event/types';
import { apiClient, apiErrorHandler } from 'src/app/common/network';
import moment from 'moment';

const AGENT_URL = window.envConfig['REACT_APP_APIM_BASE_URL'];
const APIM_AGENT = window.envConfig['REACT_APP_APIM_AGENT'];

const getReportDateRange = (data: GpReportPayload) => {
  const { eventEndDate, eventStartDate } = data;
  if (eventEndDate && eventStartDate) {
    return {
      eventEndDate: moment(eventEndDate).endOf('D').toISOString(),
      eventStartDate: moment(eventStartDate).startOf('D').toISOString(),
    };
  }

  if (eventEndDate) {
    return {
      eventEndDate: moment(eventEndDate).endOf('D').toISOString(),
      eventStartDate: moment(eventEndDate).startOf('D').subtract(6, 'months').toISOString(),
    };
  }

  if (eventStartDate) {
    return {
      eventStartDate: moment(eventStartDate).startOf('D').toISOString(),
      eventEndDate: moment(eventStartDate).endOf('D').add(6, 'months').toISOString(),
    };
  }

  return {
    eventEndDate: moment().endOf('D').toISOString(),
    eventStartDate: moment().startOf('D').subtract(6, 'months').toISOString(),
  };
};

const convertReportPayload = (params: GpReportPayload) => {
  const { page, limit, eventName, roleAdActing } = params;
  const { eventStartDate, eventEndDate } = getReportDateRange(params);
  const dataFilters = Object.keys(params).reduce((data: any, key) => {
    if (key === 'eventName' && eventName) {
      return [
        ...data,
        {
          name: 'materialName',
          value: eventName,
          type: 'String',
          operator: 'search',
        },
      ];
    }

    if (key === 'eventStartDate' && eventStartDate) {
      return [
        ...data,
        {
          name: 'materialEventStartDate',
          value: eventStartDate,
          type: 'Date',
          operator: 'gt',
        },
      ];
    }

    if (key === 'eventEndDate' && eventEndDate) {
      return [
        ...data,
        {
          name: 'materialEventEndDate',
          value: eventEndDate,
          type: 'Date',
          operator: 'lte',
        },
      ];
    }

    return data;
  }, []);

  return {
    dataFilters,
    page,
    limit,
    roleAdActing,
  };
};

export const fetchListBopReportRequest = async (
  params: GpReportPayload,
  dispatch?: Dispatch<any>,
): Promise<PaginateListMore<BopReportItem>> => {
  const uri = `${AGENT_URL}${APIM_AGENT}/ad/report/event-bop`;

  const payload = convertReportPayload(params);

  return apiClient
    .post<PaginateListMore<BopReportItem>>(uri, payload)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const fetchBopReportDownloadRequest = async (
  params: { id: string },
  dispatch?: Dispatch<any>,
): Promise<void> => {
  const uri = `${AGENT_URL}${APIM_AGENT}/ad/report/event-bop/export`;

  return apiClient
    .post<Blob>(uri, params, { responseType: 'blob' })
    .then((response) => {
      let fileName = 'bop-report-' + new Date().toISOString() + '.pdf';
      const contentDisposition = response.headers['content-disposition'];
      const fileNameStarMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
      if (fileNameStarMatch && fileNameStarMatch[1]) {
        fileName = decodeURIComponent(fileNameStarMatch[1]);
      }
      // 2. Nếu không có filename*, thử lấy theo filename chuẩn cũ
      else {
        const fileNameMatch = contentDisposition.match(/filename="?([^;"]+)"?/i);
        if (fileNameMatch && fileNameMatch[1]) {
          fileName = fileNameMatch[1];
        }
      }

      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};
